module.exports = __webpack_public_path__ + "img/9_43.6301bb80.png";